import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { NotificationWithCross } from '../NotificationWithCross'
import { useTranslation } from 'react-i18next'

export const ToastEscalatedHelpRequest = () => {
    const { t } = useTranslation('notifications')

    return (
        <NotificationWithCross id="mentor-escalated">
            <FontAwesomeIcon icon={['far', 'user-headset']} style={{ color: 'white', marginRight: '8px' }} />
            {t('mentor.escalated', 'Your question has been escalated to expert mentor')}
        </NotificationWithCross>
    )
}
